import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import { BASE_URL } from "./Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function RegisterNumber() {
  const [number, setRegisterNumber] = useState("");
  const [CountryCode, setCountryCode] = useState("966");
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setalert] = useState("");
  const navigate = useNavigate();

  const handleSendOtp = async (e) => {
    e.preventDefault();

    let sanitizedNumber = number.trim();

    // 👉 अगर नंबर "0" से शुरू होता है तो उसे हटा दो
    if (sanitizedNumber.startsWith("0")) {
      sanitizedNumber = sanitizedNumber.substring(1);
    }

    // केवल digits allow करो
    if (!/^\d+$/.test(sanitizedNumber)) {
      toast.error("Phone number must contain only digits.");
      return;
    }

    // validation check (अब sanitizedNumber पर)
    if (sanitizedNumber.length !== 9) {
      toast.error("Phone number must be 9 digits.");
      return;
    }

    setLoading(true);

    //console.log("first", CountryCode);

    try {
      const response = await axios.post(`${BASE_URL}/send_otp.php`, {
        mobile: sanitizedNumber, // 👉 हमेशा sanitized नंबर ही भेजना है
        countrycode: CountryCode,
      });

      console.log(response);
      if (response.data.success) {
        toast.success("OTP sent successfully!");

        console.log("number:", sanitizedNumber);
        console.log("CountryCode:", CountryCode);
        console.log("insert_id:", response.data.insert_id);
        navigate("/verify-phone", {
          state: {
            number: sanitizedNumber,
            CountryCode: CountryCode,
            insert_id: response.data.insert_id,
          },
        });
      } else {
        toast.error(response.data.message || "Failed to send OTP.");
      }
    } catch (error) {
      toast.error("Something went wrong.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container pb-5">
        <div className="row">
          <div className="col-12 pt-5">
            <div className="logo">
              <Link to="/">
                <img
                  src={`${BASE_URL}/images/fastrade_logo.jpg`}
                  style={{ width: "220px" }}
                  alt="Fast Trade "
                />
              </Link>
            </div>
          </div>

          <div className="col-12 pt-4 alert login_alert">
            {toastMessage && (
              <div className={`${alert ? "success" : "failed"} text-center`}>
                {toastMessage}
              </div>
            )}

            <div className="login-form">
              <form onSubmit={handleSendOtp}>
                <div className="form-page">
                  <h2 style={{ fontWeight: 500 }}>Create Personal Account</h2>

                  <div
                    className="inputs pt-3"
                    style={{ gap: "0px", flexDirection: "row" }}
                  >
                    <select
                      style={{
                        borderBottomLeftRadius: "11px",
                        borderTopLeftRadius: "10px",
                        background: "#cfcfcf",
                        border: "1px solid #c9c9c9",
                        outline: "none",
                        fontWeight: "500",
                        padding: "5px",
                      }}
                      value={CountryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                    >
                      <option value="966">+966</option>
                      <option value="91">+91</option>
                    </select>
                    <input
                      type="text"
                      placeholder="Phone Number"
                      value={number}
                      onChange={(e) => {
                        const input = e.target.value;

                        // Allow only digits
                        const onlyDigits = input.replace(/\D/g, "");

                        // Limit to 10 digits
                        if (onlyDigits.length <= 10) {
                          setRegisterNumber(onlyDigits);
                        }
                      }}
                      style={{
                        outline: "none",
                        width: "100%",
                        border: "1px solid #dbdbdb",
                        padding: "10px",
                        borderRadius: "0px 10px 10px 0px",
                        fontWeight: 500,
                      }}
                      maxLength="10"
                    />
                  </div>
                  <p
                    style={{
                      fontWeight: 500,
                      fontSize: "13px",
                      marginTop: "7px",
                      marginLeft: "2px",
                    }}
                  >
                    Enter the 9-digit number (e.g 551234567)
                  </p>

                  <div className="submit-btn pt-3">
                    <input
                      type="submit"
                      value={loading ? "Processing..." : "Next"}
                      className="btn btn-primary"
                      style={{
                        width: "100%",
                        backgroundColor: "#128DE5",
                        padding: "10px",
                        marginBottom: "15px",
                        fontWeight: 500,
                      }}
                      disabled={loading}
                    />
                  </div>
                  <div className="text-center">
                    <p style={{ fontWeight: 600 }}>
                      Already have an account ?{" "}
                      <Link
                        to="/login"
                        style={{ fontWeight: "800", color: "#128DE5" }}
                        className="redirect_link"
                      >
                        Log In
                      </Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
}
